import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RecuperarPassCambioClavePeticion } from 'src/app/models/recuperar-pass/recuperarPassCambioClave-peticion';
import { RecuperarPassClavePeticion } from 'src/app/models/recuperar-pass/recuperarPassClave-peticion';
import { RecuperarPassCorreoPeticion } from 'src/app/models/recuperar-pass/recuperarPassCorreo-peticion';
import { environment } from 'src/environments/environment';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Methods': '*',
    'Access-Control-Allow-Origin': '*'
  })
};

@Injectable()
export class RecuperarPassService {
  /*  urlCrearCuenta = environment.urlAmbiente + '/apiUsuariosMT/crearusuario'; */
  urlRecuperarPassCorreo = environment.urlAmbiente + '/apiUsuariosMT/recuperarclave';
  urlRecuperarPassClave = environment.urlAmbiente + '/apiUsuariosMT/validausuariocorreo';
  urlRecuperarPassCambioClave = environment.urlAmbiente + '/apiUsuariosMT/cambioclave';

  constructor(private http: HttpClient) { }

  doRecuperarCorreo(_body: RecuperarPassCorreoPeticion): Observable<any> {
    return this.http.post<any>(this.urlRecuperarPassCorreo, _body, httpOptions);
  }
  doRecuperarClave(_body: RecuperarPassClavePeticion): Observable<any> {
    return this.http.post<any>(this.urlRecuperarPassClave, _body, httpOptions);
  }
  doRecuperarPassCambioClave(_body: RecuperarPassCambioClavePeticion): Observable<any> {
    return this.http.post<any>(this.urlRecuperarPassCambioClave, _body, httpOptions);
  }
}